export default "__VITE_ASSET__CI$7YyHC__"